export var LOAD_PERMISSIONS_REQUEST = 'org/ViewOrganization/LOAD_PERMISSIONS_REQUEST';
export var LOAD_PERMISSIONS_FAILURE = 'org/ViewOrganization/LOAD_PERMISSIONS_FAILURE';
export var LOAD_PERMISSIONS_SUCCESS = 'org/ViewOrganization/LOAD_PERMISSIONS_SUCCESS';
export var UPDATE_PERMISSIONS_REQUEST = 'org/ViewOrganization/UPDATE_PERMISSIONS_REQUEST';
export var UPDATE_PERMISSIONS_FAILURE = 'org/ViewOrganization/UPDATE_PERMISSIONS_FAILURE';
export var UPDATE_PERMISSIONS_SUCCESS = 'org/ViewOrganization/UPDATE_PERMISSIONS_SUCCESS';
export var LOAD_USER_REQUEST = 'org/ViewOrganization/LOAD_USER_REQUEST';
export var LOAD_USER_FAILURE = 'org/ViewOrganization/LOAD_USER_FAILURE';
export var LOAD_USER_SUCCESS = 'org/ViewOrganization/LOAD_USER_SUCCESS ';
export var UPDATE_USER_REQUEST = 'org/ViewOrganization/UPDATE_USER_REQUEST';
export var UPDATE_USER_FAILURE = 'org/ViewOrganization/UPDATE_USER_FAILURE';
export var UPDATE_USER_SUCCESS = 'org/ViewOrganization/UPDATE_USER_SUCCESS';
export var UPDATE_USER_FIRST_NAME = 'org/ViewOrganization/UPDATE_USER_FIRST_NAME';
export var UPDATE_USER_LAST_NAME = 'org/ViewOrganization/UPDATE_USER_LAST_NAME';
export var ItemLevelMap = {
    item: 'Items',
    org: 'Organization',
    app: 'App',
    appadmin: 'App Admin',
    partner: 'Partner',
    ds: 'Dataset Row',
};
